import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import SettingDomainState, { ISettingDomainData } from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

export interface ISettingDomainResponse {
  data: any,
  code: number,
  message: string,
}

const actions: ActionTree<SettingDomainState, State> = {
  async getDomains(
    { commit }: ActionContext<SettingDomainState, State>,
    options: object,
  ): Promise<void> {
    await await HttpRequestServiceWithToken.get(
      process.env.VUE_APP_BASEURL + '/v2/domain/withUserId',
      options, (res: any) => {
        commit(mutationType.GET_DOMAIN, res)
      },
    )
  },
  async postVerifyDomain(
    { commit, dispatch, state }: ActionContext<SettingDomainState, State>,
    settingDomainData: ISettingDomainData,
  ): Promise<ISettingDomainResponse> {
    try {
      const res = await HttpRequestServiceWithToken.post(
        process.env.VUE_APP_BASEURL + '/v2/domain',
        {
          domain: settingDomainData,
        },
      )
      return res
    } catch (error) {
      throw error
    }
  },
  async deleteDomains(
    { commit, dispatch, state }: ActionContext<SettingDomainState, State>,
    ids: string[],
  ): Promise<ISettingDomainResponse> {
    try {
      const res = await HttpRequestServiceWithToken.delete(
        process.env.VUE_APP_BASEURL + '/v2/domain',
        {ids: ids.join(',')},
      )
      return res
    } catch (error) {
      throw error
    }
  },
}

export default actions
